import { ReactComponent as NoTicketIcon } from 'app/assets/img/no-ticket-icon.svg';
import React from 'react';
import styled from 'styled-components';

interface IReportEmptyProps {
  translations: any;
  height?: number;
}

export function ReportEmpty(props: IReportEmptyProps) {
  const { translations, height = 260 } = props;
  return (
    <EmptyWrapper style={{ height }}>
      <NoTicketIcon />
      <div className="empty-text">
        {translations?.['b2b.txt.haveNoData'] ??
          'Không có dữ liệu trong khoảng thời gian này'}
      </div>
    </EmptyWrapper>
  );
}

const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--color-12);
  font-size: 14px;
  svg {
    width: 56px;
    height: 56px;
    opacity: 0.6;
  }
  .empty-text {
    text-align: center;
  }
`;

export default ReportEmpty;
